import Select from 'react-select';
import { theme } from '../constants';

/**
 * Single-property dropdown. The house picked in the *other* dropdown is shown
 * but locked, so it is visible why it cannot be chosen twice.
 */
function PropertySelect({
  options,
  value,
  onChange,
  placeholder,
  lockedValue = null,
  lockedHint = 'Already selected',
  isDisabled = false,
}) {
  const selected = options.find((option) => option.value === value) || null;

  return (
    <Select
      options={options}
      value={selected}
      onChange={(option) => onChange(option ? option.value : null)}
      placeholder={placeholder}
      isClearable
      isDisabled={isDisabled}
      isOptionDisabled={(option) => option.value === lockedValue}
      noOptionsMessage={() => 'No properties found'}
      menuPortalTarget={document.body}
      menuPosition="fixed"
      formatOptionLabel={(option, meta) => (
        <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8 }}>
          <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{option.label}</span>
          {meta.context === 'menu' && option.value === lockedValue && (
            <span
              style={{
                fontSize: 10,
                fontWeight: 700,
                padding: '2px 6px',
                borderRadius: 5,
                background: '#f3f4f6',
                color: theme.textMuted,
                flexShrink: 0,
              }}
            >
              {lockedHint}
            </span>
          )}
        </span>
      )}
      styles={{
        menuPortal: (styleBase) => ({ ...styleBase, zIndex: 9999 }),
        control: (styleBase, state) => ({
          ...styleBase,
          borderRadius: 9,
          minHeight: 40,
          fontSize: 13.5,
          fontFamily: theme.font,
          borderColor: state.isFocused ? theme.accent : theme.border,
          boxShadow: state.isFocused ? `0 0 0 3px ${theme.accentSoft}` : 'none',
          '&:hover': { borderColor: theme.accent },
        }),
        placeholder: (styleBase) => ({ ...styleBase, color: theme.textFaint, fontSize: 13 }),
        singleValue: (styleBase) => ({ ...styleBase, color: theme.text, fontWeight: 600 }),
        menu: (styleBase) => ({ ...styleBase, borderRadius: 10, overflow: 'hidden', fontFamily: theme.font }),
        menuList: (styleBase) => ({ ...styleBase, maxHeight: 260 }),
        option: (styleBase, state) => ({
          ...styleBase,
          fontSize: 13,
          fontFamily: theme.font,
          cursor: state.isDisabled ? 'not-allowed' : 'pointer',
          opacity: state.isDisabled ? 0.55 : 1,
          fontWeight: state.isSelected ? 700 : 500,
          backgroundColor: state.isSelected
            ? theme.accentSoft
            : state.isFocused && !state.isDisabled
            ? '#f5f7ff'
            : theme.surface,
          color: state.isSelected ? theme.accent : state.isDisabled ? theme.textFaint : '#333',
        }),
      }}
    />
  );
}

export default PropertySelect;
